import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: 'root'
})
export class IdentityUserService {
    private url: string = environment.api.identity;

    constructor(private http: HttpClient) { }

    createIdentityUser(data: any) {
        return this.http.post(`${this.url}/identityuser/create`, data);
    }
}